<template>
    <div :class="$style.container" id="loading" v-loading.fullscreen.lock.body="loading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-container>
            <div id="collectionHome">
                <div :class="$style.left">
                    <el-row>
                        <el-col>
                            <div style="padding-top: 8px;margin-bottom:30px;font-weight: bold;">客户数据采集</div>
                        </el-col>
                    </el-row>


                </div>
                <div style="width: 100%;margin-top:30px;">
                    <el-form>
                        <el-row>
                            <el-col :span="24" style="position: relative;margin-top: 30px">
                                <span
                                    style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">采集对象</span>
                                <el-checkbox-group v-model="channelCheckList" style="display: inline-block">
                                    <el-checkbox label="INSTITUTION" style="color: #606266;">机构</el-checkbox>
                                    <el-checkbox label="HCP" style="color: #606266;">HCP</el-checkbox>
                                    <el-checkbox label="RETAILSTORE" style="color: #606266;">门店</el-checkbox>
                                    <el-checkbox label="DISTRIBUTOR" style="color: #606266;">经销商</el-checkbox>
                                    <el-checkbox label="CUSTOMTABLE" style="color: #606266;">自定义表格</el-checkbox>
                                </el-checkbox-group>
                            </el-col>
                            <el-col :span="12" style="text-align: left;margin-top:20px;">
                                <span style="font-weight: bold;display: inline-block;width: 70px">任务名称</span>
                                <el-input type="text" v-model="task_name" placeholder="请输入采集任务名称"
                                    style="width: calc(100% - 90px)">
                                </el-input>
                            </el-col>
                            <el-col :span="12" style="text-align: left;margin-top:20px;">
                                <span style="font-weight: bold;display: inline-block;width: 70px">采集日期
                                </span>
                                <div style="display: inline-block;width: calc(100% - 90px)">
                                    <el-date-picker v-model="start_date"  type="datetime" format="yyyy-MM-dd HH:mm"
                                        value-format="yyyy-MM-dd HH:mm" style="width:47%" placeholder="选择日期"
                                        @change="chooseTimeRange0">
                                    </el-date-picker><span style="display: inline-block;width: 6%;text-align: center">至
                                    </span><el-date-picker v-model="end_date"  type="datetime" format="yyyy-MM-dd HH:mm"
                                        value-format="yyyy-MM-dd HH:mm" placeholder="选择日期" style="width:47%"
                                        @change="chooseTimeRange2">
                                    </el-date-picker>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-row style="margin-top:80px;border-bottom: 2px dotted rgb(231, 234, 236);padding-bottom: 20px;">
                        <el-button type="primary" size="small" @click.stop="handleQueryClick">查询</el-button>
                        <el-button type="danger" size="small" @click.stop="handleResetClick">重置</el-button>
                    </el-row>

                    <div style="margin-bottom: 20px">
                        <el-row style="margin-top: 20px;">
                            <el-button
                                style="color: #fff;font-size: 12px;background: #4EC880;border:1px solid #4EC880;border-radius: 5px;"
                                @click.stop="handleAddClick" icon="el-icon-plus" size="small">
                                新建任务
                            </el-button>
                        </el-row>
                        <el-table :data="taskList" border style="width: 100%;margin-top: 20px" stripe>
                            <el-table-column type="selection" width="55">
                            </el-table-column>
                            <el-table-column prop="task_name" sortable label="任务名称">
                            </el-table-column>
                            <el-table-column prop="reference_obj" sortable label="采集对象" width="220">
                                <template slot-scope="scope">
                                    <span v-for="item in scope.row.reference_obj" v-if="item == 'HCP'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        HCP
                                    </span>
                                    <span v-for="item in scope.row.reference_obj" v-if="item == 'INSTITUTION'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        机构
                                    </span>
                                    <span v-for="item in scope.row.reference_obj" v-if="item == 'RETAILSTORE'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        门店
                                    </span>
                                    <span v-for="item in scope.row.reference_obj" v-if="item == 'DISTRIBUTOR'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        经销商
                                    </span>
                                    <span v-for="item in scope.row.reference_obj" v-if="item == 'CUSTOMTABLE'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        自定义表格
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="field_num" sortable label="采集字段数">
                            </el-table-column>
                            <!-- <el-table-column prop="completed_num" sortable label="已采集记录数">
                            </el-table-column> -->
                            <el-table-column prop="start_date" sortable label="开始日期">

                            </el-table-column>
                            <el-table-column prop="end_date" label="结束日期" sortable>

                            </el-table-column>
                            <el-table-column fixed="right" label="操作" width="160" style="color: #3b99f7">
                                <template slot-scope="scope">
                                    <el-button style="color: #fff;background: #FE904C;border:none;border-radius: 10%"
                                        size="small" @click="handleDetail(scope.row)">详情
                                    </el-button>
                                    <el-button type="primary" style="color: #fff;border:none;border-radius: 10%"
                                        size="small" @click="handleCopyDetail(scope.row)">复制
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <pagination :page="page" @changePage="changePageClick"></pagination>
                    </div>
                </div>

                <el-dialog :visible.sync="addTaskDetails" width="700px" :show-close="false"
                    style="vertical-align: center;">
                    <div style="">
                        <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                            <el-col :span="12">
                                <div style="color: #3998F7;font-size: 26px">新建任务
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div align="right">
                                    <el-button type="primary" size="small" @click.stop="add">
                                        保存
                                    </el-button>
                                    <el-button type="danger" size="small" @click.stop="close">
                                        关闭
                                    </el-button>
                                </div>
                            </el-col>
                        </el-row>
                        <div style="margin-top: 20px;">
                            <el-form :model="addTaskForm" ref="ruleForm" label-width="200px" class="demo-ruleForm"
                                hide-required-asterisk>
                                <el-form-item label="任务名称" prop="task_name" :rules="[
                                    { required: true, message: '任务名称不能为空' },]" class="collectionHome_star">
                                    <el-input v-model="addTaskForm.task_name" placeholder="请输入内容"
                                        style="width: 70%"></el-input>
                                </el-form-item>
                                <el-form-item label="采集对象" prop="reference_obj" :rules="[
                                    { required: true, message: '采集对象不能为空' },]" class="collectionHome_star">
                                    <el-select v-model="addTaskForm.reference_obj" multiple placeholder="请选择" @change="selectRefreenceObj()"
                                        style="width: 70%">
                                        <el-option v-for="item in collectObject" :key="item.id" :label="item.value"
                                            :value="item.id" >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="开始日期" prop="start_date" :rules="[
                                    { required: true, message: '开始时间不能为空' },]" class="collectionHome_star">
                                    <el-date-picker v-model="addTaskForm.start_date" type="datetime" format="yyyy-MM-dd HH:mm"
                                        value-format="yyyy-MM-dd HH:mm" placeholder="选择日期" style="width: 70%"
                                        @change="chooseTimeRange0">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="结束日期" prop="end_date" :rules="[
                                    { required: true, message: '结束时间不能为空' },]" class="collectionHome_star">
                                    <el-date-picker v-model="addTaskForm.end_date"type="datetime" format="yyyy-MM-dd HH:mm"
                                        value-format="yyyy-MM-dd HH:mm" placeholder="选择日期" style="width: 70%"
                                        @change="chooseTimeRange2">
                                    </el-date-picker>
                                </el-form-item>

                                <el-form-item label="采集辖区" prop="territory_id" :rules="[
                                    { required: true, message: '采集辖区不能为空' },]" class="collectionHome_star">
                                    <el-cascader v-model="addTaskForm.territory_id" :options="territoryList"
                                        :props="{ multiple: true, checkStrictly: true }" :show-all-levels="false"
                                        style="width:70%" clearable>
                                    </el-cascader>
                                </el-form-item>
                                <el-form-item label="采集模板" prop="template_id" :rules="[
                                    { required: true, message: '采集模板不能为空' },]" class="collectionHome_star">
                                     <el-select v-model="addTaskForm.template_id" placeholder="请选择"
                                        style="width: 70%">
                                        <el-option v-for="item in groupList" :key="item.group_id" :label="item.label"
                                            :value="item.group_id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="说明">
                                    <el-input v-model="addTaskForm.comments" type="textarea" :rows="2"
                                        placeholder="请填写说明" style="width: 70%"></el-input>
                                </el-form-item>


                            </el-form>

                        </div>
                    </div>

                </el-dialog>
            </div>
        </el-container>


    </div>
</template>

<script>
import http from '../../APIService/http'
import pagination from '../../components/pagination'

import { Message } from "element-ui";
import moment from 'moment'


export default {
    name: "CollectionHome",
    data() {
        return {
            loading: false,
            channelCheckList: [],
            searchForm: {},
            addTaskDetails: false,
            collectObject: [
                {
                    id: 'HCP',
                    value: 'HCP'
                }, {
                    id: 'INSTITUTION',
                    value: '机构'
                }, {
                    id: 'RETAILSTORE',
                    value: '门店'
                }, {
                    id: 'DISTRIBUTOR',
                    value: '经销商'
                }, {
                    id: 'CUSTOMTABLE',
                    value: '自定义表格'
                },
            ],
            addTaskForm: {
                task_name: '',
                reference_obj: [],
                start_date: '',
                end_date: '',
                template_id: '',
                comments: '',
                territory_id: []

            },
            territoryList: [],
            groupList: [],
            task_name: '',
            start_date: '',
            end_date: '',
            taskList: [],
            page: {
                current: 1,
                size: 5,
                total: 0
            }

        }
    },
    components: {
        pagination,
    },
    methods: {
        handleQueryClick() {
            this.page = {
                current: 1,
                size: 5,
                total: 0
            }
            this.getCollectTask()
        },
        handleResetClick() {
            this.task_name = ''
            this.start_date = ''
            this.end_date = ''
            this.channelCheckList = []
        },
        async handleAddClick() {
            this.addTaskForm = {
                task_name: '',
                reference_obj: [],
                start_date: '',
                end_date: '',
                template_id: '',
                comments: ''
            }
            if (this.territoryList.length == 0) {
                await this.getTerritoryList(true);
            }
            this.addTaskDetails = true
        },
        add() {
            this.$refs["ruleForm"].validate(valid => {
                if (!valid) {
                    return false
                } else {
                    this.addTask()
                }
            })
        },
        async getTerritoryList(isloading) {
            try {
                if (isloading) {
                    this.loading = true;
                }
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                    user_id: user.user_id,
                }
                await http.post('/wapi/Collect/getTerritoryList', data).then(res => {
                    if (res.success == true) {
                        console.log(res.data)
                        this.territoryList = res.data
                        localStorage.setItem('territoryList', JSON.stringify(this.territoryList))

                    }
                    if (isloading) {
                        this.loading = false;
                    }

                })
            } catch (e) {
                if (isloading) {
                    this.loading = false;
                }
            }

        },
        selectRefreenceObj(e){
            console.log(e)
            this.getGroupList()
        },
        async getGroupList() {
            let loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            try {
                let user = this.$store.getters.getUser

                this.groupList = []
                for (const item of this.addTaskForm.reference_obj) {
                    let data = {
                        tenant_id: user.tenant_id,
                        reference_obj: item
                    }
                    await http.post('/wapi/Collect/getCollectField', data).then(res => {
                        if (res.success) {
                            for (let i = 0; i < res.data.ary2.length; i++) {
                                this.groupList.push(res.data.ary2[i])
                            }
                        }
                    })
                }
                loading.close()
            } catch (e) {
                loading.close()
            }

        },
        addTask() {
            let user = this.$store.getters.getUser
            let data = {
                tenant_id: user.tenant_id,
                user_id: user.user_id,
                task_name: this.addTaskForm.task_name,
                reference_obj: this.addTaskForm.reference_obj,
                start_date: this.addTaskForm.start_date,
                end_date: this.addTaskForm.end_date,
                comments: this.addTaskForm.comments,
                template_id: this.addTaskForm.template_id,
                territory_id: this.addTaskForm.territory_id
            }
            http.post('/wapi/Collect/addCollectTask', data).then(res => {
                if (res.success == true) {
                    this.addTaskDetails = false
                    Message({
                        type: 'success',
                        message: '保存成功'
                    })
                    this.getCollectTask()

                }

            })

        },
        close() {
            this.$refs.ruleForm.resetFields();
            this.addTaskDetails = false
        },
        chooseTimeRange0(t) {
            let time1 = moment(t).valueOf()
            let time2 = moment(this.addTaskForm.end_date).valueOf()
            if (time1 >= time2) {
                this.$message({
                    type: "warning",
                    message: "结束日期应晚于开始日期"
                })
                this.addTaskForm.end_date = ''
            }

        },
        chooseTimeRange2(t) {

            let time1 = moment(t).valueOf()
            let time2 = moment(this.addTaskForm.start_date).valueOf()


            if (time1 < time2) {
                this.$message({
                    type: "warning",
                    message: "结束日期应晚于开始日期"
                })
                this.addTaskForm.end_date = ''
            }
        },

        async getCollectTask() {
            let loading1 = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            try {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    reference_obj: this.channelCheckList,
                    task_name: this.task_name,
                    start_date: this.start_date,
                    limit: this.page.size,
                    offset: this.page.current - 1,
                    end_date: this.end_date
                }
                await http.post('/wapi/Collect/getCollectTask', data).then(res => {

                    if (res.success) {
                        this.taskList = res.data.result
                        this.taskList.forEach(item => {
                            item.start_date =item.end_date.length>10? moment(item.start_date).format('YYYY年MM月DD日 HH:mm'): moment(item.start_date).format('YYYY年MM月DD日')
                            item.end_date =item.end_date.length>10? moment(item.end_date).format('YYYY年MM月DD日 HH:mm'): moment(item.end_date).format('YYYY年MM月DD日')
                        })
                        this.page.total = res.data.arrayCount
                        loading1.close()

                    } else {
                        Message.error(res.message);
                    }
                })
            } catch (e) {
                loading1.close()
            }

        },
        // 改变页码信息
        changePageClick(page, size) {
            if (page) {
                this.page.current = page
            }
            if (size) {
                this.page.size = size
            }
            this.getCollectTask()
        },
        handleDetail(row) {
            localStorage.setItem('collection', 1)
            this.searchForm = row
            console.log("-----taskrow----")
            console.log(row)
            this.$router.push({ name: 'taskProfile', params: row })
        },

        handleCopyDetail(row) {

            this.$confirm('确定复制该任务吗, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                    user_id: user.user_id,
                    task_id: row.task_id
                }
                http.post('/crm/web/collection/copyTask', data).then(res => {
                    if (res.success == true) {
                        localStorage.setItem('collection', 1);
                        this.$router.push({ name: 'taskProfile', params: res.data })
                    } else {
                        this.error("复制失败")
                    }

                })
            }).catch(() => {

            });
        },
        beforeRouteLeave(to, from, next) {

            // 打开详情页（或者下一个任意界面）之前，把筛选条件保存到localStorage，如果离开列表页并且打开的不是详情页则清除，也可以选择不清除
            if (to.name === 'taskProfile') {
                let collectDataList = JSON.stringify(this.searchForm)
                localStorage.setItem('collectDataList', collectDataList)
            } else {
                localStorage.removeItem('collectDataList')
            }
            if (to.name !== 'taskProfile') {
                this.GLOBAL.page_medical = {
                    current: 1,
                    size: 5,
                    total: 0
                }
            }
            next()
        }


    },
    created() {
        this.getCollectTask()


        // this.territoryList = JSON.parse(localStorage.getItem('territoryList')) ? JSON.parse(localStorage.getItem('territoryList')) : []
        if (this.territoryList.length == 0) {
            this.getTerritoryList()
        }

    },
    mounted() {

    },
    updated() {
    },
    beforeDestroy() {

    },
    computed: {

    },
    watch: {

    }
}
</script>
<style lang="scss" module>
.container {
    background: white;
    height: 100%;
    overflow: auto;

    .left {
        font-size: 18px;
        font-weight: bold;
        color: #000000;
        float: left;
        position: absolute;
        z-index: 1;

        .type {
            em {
                color: #d98f2f;
                font-size: 14px;
                font-weight: bold;
            }
        }

        .first {
            color: #555555;
            font-size: 20px;
        }

        .font {
            margin-left: 20px;
            font-size: 14px;
            color: #555555;
        }
    }

    .right {
        margin-top: -20px;
        width: 100%;

        .header {
            width: 100%;
            padding-bottom: 6px;
            border-bottom: 2px dotted #e7eaec;

        }

        .body {
            overflow: auto;

        }
    }

    .noData {}
}
</style>
<style scoped>
.el-container {
    height: 100%;
    padding: 20px;
    background: white;
}

#collectionHome {
    width: 100%;
    background: white;
    position: relative;
}

#collectionHome>>>.el-dialog__header {
    padding-top: 0
}

#collectionHome>>>.el-form-item__label {
    font-size: 14px;
    color: black;
    font-weight: bold;
}

#collectionHome>>>.el-tag.el-tag--info {
    background: #FF9901;
    color: #FFFFFF;
    border: none;
}

#collectionHome>>>.el-tag.el-tag--info .el-tag__close {
    display: none;
}

#collectionHome>>>.collectionHome_star label:after {
    content: '*';
    color: #F56C6C;
    margin-left: 4px;
}
</style>


// WEBPACK FOOTER //
// src/pages/collection/home.vue